<div class="row page-header">
    <div class="col-12">
        <h1>Materials <small>Invoice line items VanCon has been billed for</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar" style="margin-top: 15px">
                <div class="col-12">
                    <form class="form-inline">
                        <div class="input-header-group">
                            <span class="input-header">Start Date</span>
                            <wj-input-date
                                [(ngModel)]="startDate"
                                (ngModelChange)="refresh()"
                                name="startDate"
                                style="width: 125px; height: 32px; margin-top: 4px"
                            ></wj-input-date>
                        </div>
                        <div class="input-header-group">
                            <span class="input-header">End Date</span>
                            <wj-input-date
                                [(ngModel)]="endDate"
                                (ngModelChange)="refresh()"
                                name="endDate"
                                style="width: 125px; height: 32px; margin-top: 4px"
                            ></wj-input-date>
                        </div>
                        <div class="input-header-group">
                            <span class="input-header">Category</span>
                            <select
                                class="form-select form-select-sm"
                                style="width: auto; height: 32px; margin-top: 4px"
                                name="category"
                                [(ngModel)]="category"
                                (ngModelChange)="refresh()"
                            >
                                <option value="">All</option>
                                @for (item of categories; track item) {
                                    <option [value]="item">{{ item }}</option>
                                }
                            </select>
                        </div>
                        <div class="input-header-group">
                            <span class="input-header">Item contains</span>
                            <input
                                class="form-control"
                                style="width: 220px; height: 32px; margin-top: 4px"
                                name="search"
                                [(ngModel)]="search"
                                (change)="refresh()"
                                (keyup.enter)="refresh()"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <ul ngbNav [(activeId)]="activeTab" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Overview</a>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Items</a>
        </li>
        <li [ngbNavItem]="3">
            <a ngbNavLink>Prices</a>
        </li>
        <li [ngbNavItem]="4">
            <a ngbNavLink>Similar Items</a>
        </li>
        <li [ngbNavItem]="5">
            <a ngbNavLink>Vendors</a>
        </li>
        <li [ngbNavItem]="6">
            <a ngbNavLink>Vista Vendors</a>
        </li>
        <li [ngbNavItem]="7">
            <a ngbNavLink>Jobs</a>
        </li>
        <li [ngbNavItem]="8">
            <a ngbNavLink>Equipment</a>
        </li>
        <li [ngbNavItem]="9">
            <a ngbNavLink>Data Quality</a>
        </li>
    </ul>
    <div class="mt-2" [hidden]="!isTab(1)">
        <app-purchased-materials-overview
            [filters]="filters()"
            [active]="isTab(1)"
            (categoriesLoaded)="mergeCategories($event)"
        ></app-purchased-materials-overview>
    </div>
    <div class="mt-2" [hidden]="!isTab(2)">
        <app-purchased-materials-items
            [filters]="filters()"
            [active]="isTab(2)"
            (priceHistory)="showPriceHistory($event)"
        ></app-purchased-materials-items>
    </div>
    <div class="mt-2" [hidden]="!isTab(3)">
        <app-purchased-materials-prices
            [filters]="filters()"
            [active]="isTab(3)"
            [description]="priceDescription()"
        ></app-purchased-materials-prices>
    </div>
    <div class="mt-2" [hidden]="!isTab(4)">
        <app-purchased-materials-similar [filters]="filters()" [active]="isTab(4)"></app-purchased-materials-similar>
    </div>
    <div class="mt-2" [hidden]="!isTab(5)">
        <app-purchased-materials-vendors [filters]="filters()" [active]="isTab(5)"></app-purchased-materials-vendors>
    </div>
    <div class="mt-2" [hidden]="!isTab(6)">
        <app-purchased-materials-vista-vendors [filters]="filters()" [active]="isTab(6)"></app-purchased-materials-vista-vendors>
    </div>
    <div class="mt-2" [hidden]="!isTab(7)">
        <app-purchased-materials-jobs [filters]="filters()" [active]="isTab(7)"></app-purchased-materials-jobs>
    </div>
    <div class="mt-2" [hidden]="!isTab(8)">
        <app-purchased-materials-equipment [filters]="filters()" [active]="isTab(8)"></app-purchased-materials-equipment>
    </div>
    <div class="mt-2" [hidden]="!isTab(9)">
        <app-purchased-materials-quality [filters]="filters()" [active]="isTab(9)"></app-purchased-materials-quality>
    </div>
</div>
